// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__R6OWI","comment":"styles_comment__325ME"};